import React, { useContext } from 'react';
import { Table, Tag, Space } from 'antd';
import 'antd/dist/antd.css';
import { GithubContext } from '../context/context';

const Main = () => {
  const { followers } = useContext(GithubContext);

  const columns = [
    {
      title: 'Avatar',
      dataIndex: 'avatar',
      key: 'avatar',
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Repository',
      dataIndex: 'repository',
      key: 'repository',
    },
  ];

  const data = followers.map((follower, id) => {
    return {
      key: follower.id,
      avatar: (
        <img
          style={{ maxWidth: '50px', borderRadius: '50%' }}
          src={follower.avatar_url}
        />
      ),
      username: follower.login,
      repository: <a href={follower.url} target="_blank">Visit</a>,
    };
  });
  

  return (
    <Table
      className="table"
      columns={columns}
      dataSource={data}
    />
  );
};

export default Main;
